import { PlanCurrency } from './planCurrency.constants';

export { PLAN_CURRENCIES, PlanCurrency } from './planCurrency.constants';

export function normalizePlanCurrency(code?: string | null): string {
  const upper = String(code ?? '').trim().toUpperCase();
  return PlanCurrency.SUPPORTED.includes(upper) ? upper : 'EGP';
}

export function planCurrencySymbol(code?: string | null): string {
  return PlanCurrency.symbol(normalizePlanCurrency(code));
}

export function planCurrencyLabel(code?: string | null): string {
  return PlanCurrency.label(normalizePlanCurrency(code));
}

/** Format amount with plan/admin currency symbol. */
export function formatPlanMoney(
  amount: string | number | null | undefined,
  currency?: string | null,
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number },
): string {
  if (amount === null || amount === undefined || amount === '' || amount === 'null') {
    return '—';
  }
  const num = typeof amount === 'number' ? amount : Number(amount);
  if (!Number.isFinite(num)) {
    return String(amount);
  }
  const symbol = planCurrencySymbol(currency);
  const formatted = num.toLocaleString('ar-EG', {
    minimumFractionDigits: options?.minimumFractionDigits ?? 0,
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  });
  return `${formatted} ${symbol}`;
}
